import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import LineBtn from "../../../Button/LineBtn";
import FaqCategoryDeleteModal from "./FagCategory/FaqCategoryDeleteModal";
import FaqCategoryModal from "./FagCategory/FaqCategoryModal";

export default function ManageFaqButtons() {
  const navigate = useNavigate();
  const [inputCategoryModal, setInputCategoryModal] = useState(false);
  const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);

  return (
    <ManageFaqButtonContainer>
      <LineBtn
        icon="add"
        btnText="자주 묻는 질문 추가"
        sPadding="0 12px 0 10px"
        btnHeight={38}
        btnClickEvent={() => navigate("/linkid-manage/faq/add")}
      />

      <LineBtn
        icon="edit"
        btnText="카테고리 추가 및 변경"
        sPadding="0 12px 0 10px"
        btnHeight={38}
        btnClickEvent={() => {
          setInputCategoryModal(true);
        }}
      />

      <LineBtn
        icon="delete"
        btnText="카테고리 삭제"
        sPadding="0 12px 0 10px"
        btnHeight={38}
        btnClickEvent={() => {
          setDeleteCategoryModal(true);
        }}
      />

      {/* 카테고리 추가 및 변경 모달 */}
      {inputCategoryModal && (
        <FaqCategoryModal closeEvent={() => setInputCategoryModal(false)} />
      )}

      {/* 카테고리 삭제 모달 */}
      {deleteCategoryModal && (
        <FaqCategoryDeleteModal
          closeEvent={() => setDeleteCategoryModal(false)}
        />
      )}
    </ManageFaqButtonContainer>
  );
}

const ManageFaqButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  @media screen and (max-width: 1200px) {
    justify-content: flex-start;
  }
`;
